import { gql } from '@apollo/client'

export default gql(`
    mutation ($id: ID! $masterConfigEnabled: Boolean! $masterConfigSchemaId: ID!) {
        updateModuleSettings(input: {
            id: $id
            channelManagerSetting:{
                masterConfigEnabled: $masterConfigEnabled
                masterConfigSchemaId: $masterConfigSchemaId
            }
        })
        {
            id
            channelManagerSetting {
                masterConfigEnabled
                masterConfigSchemaId
            }  
        }
   }`
)
